module.exports = __webpack_public_path__ + "img/icon-divider1.c0c7f0ab.svg";